export default "__VITE_ASSET__ByqH866i__"